<template>
  <div id="#app">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/about' }"
          >关于大研会</el-breadcrumb-item
        >
        <el-breadcrumb-item>大研会简介</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="article-detail">
      <div v-html="intro"></div>
    </div>
  </div>
</template>

<script>
import { about } from "../../api/index.js";
export default {
  data() {
    return {
      intro: "",
      articleBelong: 1,
    };
  },
  created() {
    about({ articleBelong: this.articleBelong }).then((res) => {
      this.intro = res.data.result.records[0].content;
    });
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 15px;
}

.breadcrumb {
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
  color: #999;
  margin-bottom: 25px;
}
</style>
